import { useEffect, useState } from "react";
import { fetchRemakeOption } from "@apis/http/api";
import { DEFAULT_VIDEO_SPECS_VALUE } from "./videoSpecsRules";
import type { VideoSpecsOptions } from "./types";

const EMPTY_OPTIONS: VideoSpecsOptions = {
  aspectRatioOptions: [],
  resolutionOptions: [],
  defaultAspectRatio: DEFAULT_VIDEO_SPECS_VALUE.aspectRatio,
  defaultResolution: DEFAULT_VIDEO_SPECS_VALUE.resolution,
};

export const useVideoSpecsOptions = () => {
  const [options, setOptions] = useState<VideoSpecsOptions | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let ignore = false;
    const getOptions = async () => {
      setLoading(true);
      try {
        const response = await fetchRemakeOption();
        if (ignore) return;
        const {
          aspectRatioOptions = [],
          resolutionOptions = [],
          defaultAspectRatio = DEFAULT_VIDEO_SPECS_VALUE.aspectRatio,
          defaultResolution = DEFAULT_VIDEO_SPECS_VALUE.resolution,
        } = response ?? {};

        setOptions({
          aspectRatioOptions,
          resolutionOptions,
          defaultAspectRatio,
          defaultResolution,
        });
      } catch {
        if (!ignore) setOptions(EMPTY_OPTIONS);
      } finally {
        if (!ignore) setLoading(false);
      }
    };

    getOptions();
    return () => {
      ignore = true;
    };
  }, []);

  return { options, loading };
};
